<template>
  <b-row>
    <b-col cols="12">
      <tabela-repeticao
        v-model="ieItens"
        :colunas="ieColunas"
        :validar="validar"
      >
        <template #visualizacao="{slotScope: {valor, key, tipo}}">
          <span v-if="tipo === 'data'">
            {{ dataFormatada(valor) }}
          </span>
          <span v-else>
            {{ key==='uf' ? valor.sigla : valor }}
          </span>
        </template>

        <template #edicao="{slotScope: {item, key, tipo, classe}}">
          <estado-select
            v-if="key === 'uf'"
            v-model="item[key]"
            :invalido="item.erro && item.erro[key]"
          />
          <div v-else-if="tipo === 'data'">
            <data-input
              v-model="item[key]"
              :caledario="false"
              :required="false"
              :invalid="item.erro && item.erro[key]"
            />
          </div>
          <b-input
            v-else
            v-model="item[key]"
            :class="[{'is-invalid' : item.erro && item.erro[key]}, classe]"
          />
        </template>
      </tabela-repeticao>
    </b-col>
  </b-row>
</template>

<script>
import { formatDate } from '@core/utils/filter'
import { mapGetters } from 'vuex'

export default {
  name: 'IncricaoEstadual',
  components: {
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    TabelaRepeticao: () => import('@/shared/components/tabela-repeticao/TabelaRepeticao.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
  },
  data() {
    return {
      valueInner: [],
      ieColunas: [
        { key: 'ie', label: 'Inscrição' },
        { key: 'uf', label: 'Estado' },
        { key: 'dataEmissao', label: 'Data de emissão', tipo: 'data' },
        { key: 'dataBaixa', label: 'Data de baixa', tipo: 'data' },
      ],
    }
  },
  computed: {
    ...mapGetters('empresa', ['ieItens']),
  },
  methods: {
    dataFormatada(data) {
      if (data && (data instanceof Date || data.indexOf('T') > 0)) {
        return formatDate(data, { month: 'numeric', day: 'numeric', year: 'numeric' })
      }
      return data
    },
    validar(item) {
      this.$set(item, 'erro', {})

      if (!item.ie) {
        this.$set(item.erro, 'ie', true)
        return false
      }

      if (item.ie && item.ie.trim().toLowerCase() !== 'isento') {
        let valido = true
        if (!item.uf || !item.uf.sigla) {
          this.$set(item.erro, 'uf', true)
          valido = false
        }
        if (!item.dataEmissao) {
          this.$set(item.erro, 'dataEmissao', true)
          valido = false
        }
        return valido
      }
      return true
    },
  },
}
</script>
